<template>
  <div class="protocol login-protocol">
    <navigation>用户注册协议</navigation>
    <section class="content">
      <p class="text tab-2">
        <b>为了保障您的权益，我们（详见定义条款）提示您，请在使用平台服务（详见定义条款）前，详细阅读并理解本协议（详见定义条款）的所有内容，特别是信息的收集、使用与分享条款、免除或者限制责任的条款、争议解决和法律适用条款以及开通或使用某项服务的单独协议，及选择接受或不接受的部分。以粗体标识的条款，您应重点阅读并理解。一旦您以任何方式进入平台并使用平台服务，即视为您已充分阅读、理解并接受本协议的全部内容（包括但不限于本协议正文及所附超链接的全部内容），并与平台达成协议。如您对本协议有任何疑问的，应向平台客服咨询。如果您不同意本协议的部分或全部约定，您应立即停止使用平台服务并通过平台客服与平台联系。</b>
      </p>
      <p class="text tab-2">
        您与平台达成协议后，您承诺接受并遵守本协议的约定，并不得以未阅读本协议的内容或者未获得平台对您问询的解答等理由，主张本协议无效，或要求撤销本协议。<b>在本协议履行过程中，平台可以依其单独判断暂时停止提供、限制或改变平台服务，并有权根据自身业务需要随时修订本协议。一旦本协议的内容发生变动，平台将通过平台公告的形式公布最新的注册协议，变更后的协议自公告发布之日起生效。如果您不同意平台对本协议所做的修改，您应立即停止使用平台服务并通过平台客服与平台联系。如果您继续使用平台服务，则视为您接受平台对本协议所做的修改，并应遵照修改后的协议执行。用户经平台引导，直接将相关信息提交、授权给我们第三方合作机构的平台而非本平台的，平台不承担相关的任何责任与赔偿。您知晓，您与我们第三方合作机构所产生的任何争议将依据您和该等相关第三方所签订的服务协议约束并依据相应服务协议来处理。请您在使用第三方合作机构提供的服务前，仔细阅读该等第三方合作机构的用户协议及个人信息保护政策，并进行审慎决策。</b>
      </p>
      <p class="text tab-2">
        <b>本协议内容包括协议正文、法律声明、隐私权政策、平台规则及所有平台已经发布或将来可能发布的各类服务规则（包括但不限于《天美平台用户注册协议》）、产品使用规则、公告或通知（以下简称“本协议”）。所有该等规则、公告或通知为本协议不可分割的组成部分，与本协议具有同等法律效力。</b>
      </p>
      <p class="text tab-2">定义：</p>
      <div>
       
        <p class="text tab-2">1. 平台：是指我们为用户提供服务的相应网站、小程序、移动客户端以及以其他形式提供的操作环境（包括未来技术发展出现的新的形态）。本平台属于平台运营者所有并运营的天美平台之一。 </p>
          
        <p class="text tab-2">2. 平台服务或服务：是指平台运营者基于平台向您提供的各项服务。</p> 
          
        <p class="text tab-2">3. 统一登录账号：用户在本平台注册后，将取得供您使用的统一登录账号，您使用统一登录账号即可登录本平台，该统一登录账号也可用于登录平台运营者运营的其他天美平台。</p> 
          
          
        <p class="text tab-2">4. 平台运营者/我们：是指重庆市崇天小额贷款有限公司。本协议项下，平台运营者可能根据平台的业务调整而发生变更，变更后的平台运营者与您共同履行本协议并向您提供服务，平台运营者的变更不会影响您本协议项下的权益。平台运营者还有可能因为提供新的平台服务而新增，如您使用新增的平台服务的，视为您同意新增的平台运营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您缔约、履约的主体及争议相对方。</p> 
          
        <p class="text tab-2">5. 平台规则：包括在平台已经发布及后续发布的全部规则、解读、公告等内容以及在帮助中心内发布的各类规则、实施细则、流程说明等。 </p>
       
      </div>
      <p class="text tab-2"><b>一、账户注册及使用</b></p>
      <p class="text tab-2">
        1.
        您知晓并同意，您在本平台注册后，将取得供您使用的统一登录账号，您使用统一登录账号即可登录本平台，该统一登录账号也可用于登录平台运营者旗下的其他平台。您在使用统一登录账号登录其他平台时需要再次确认该等平台的注册协议、服务协议、隐私权政策等各类规则（如有）。统一登录账号的登录名是您的手机号码。
      </p>
      <p class="text tab-2">
        2.
        您确认，在您开始注册程序使用平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力并符合本协议第二条平台用户中要求的其他条件。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
      </p>
      <p class="text tab-2">
        3.
        您的注册账户为您自行设置并由您保管，平台任何时候均不会主动要求您提供您的账户密码。您注册了平台账户则会被视为平台用户，建议您务必保管好您的平台账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开平台。注册账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，平台将不承担责任，您应通过司法、行政等救济途径向侵权行为人追责。
      </p>
      <p class="text tab-2">
        4.
        您不得将在平台注册获得的账户借给他人使用，否则您应承担由此产生的全部责任，并与实际使用人承担连带责任。
      </p>
      <p class="text tab-2">
        5.
        您同意，平台有权在未告知您的情形下使用您的注册信息、用户名、密码等信息，登录进入您的注册账户，进行证据保全，包括但不限于公证、见证等。
      </p>
      <p class="text tab-2"><b>二、平台用户</b></p>
      <p class="text tab-2">
        1.
        平台用户应遵循诚实守信、责任自负、风险自担的原则承担使用平台服务所产生的风险，在使用服务应当同时具备以下条件：
      </p>
      <p class="text tab-2">
        （1）具有完全民事权利和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织；
      </p>
      <p class="text tab-2">（2）按照平台要求进行实名注册；</p>
      <p class="text tab-2">
        （3）相应法律法规及平台规定、及平台有关协议约定的其他条件。
      </p>
      <p class="text tab-2">
        <b>2. 平台有权要求平台用户提供真实、准确、完整、合法有效的个人信息。</b>
      </p>
      <p class="text tab-2">
        3.
        平台账户将记载平台用户在平台的所有活动，是平台用户登录平台并使用服务时的唯一账户。该用户账号和密码由平台用户负责保管；用户应当对以其用户账号进行的所有活动和事件负法律责任。
      </p>
      <p class="text tab-2">
        4.
        每个平台用户有义务维持并更新平台用户的资料，确保其真实、最新、有效及完整；承诺按约定如实报告影响或可能影响交易对方权益的重大信息。若平台用户提供任何错误、虚假、失效或不完整的资料，或者平台依其独立判断怀疑资料为错误、虚假、失效或不完整，平台有权暂停、终止或以其他方式限制平台用户的平台账户，并拒绝平台用户使用平台服务的部分或全部功能。<b>在此情况下，平台不承担任何责任，并且平台用户或其监护人同意承担用户及平台因此所产生的直接或间接的任何支出或损失。</b>
      </p>
      <p class="text tab-2">
        <b>如因平台用户未及时更新基本资料，导致平台服务无法提供或提供时发生任何错误，平台不承担任何责任，平台用户自行承担相应后果。</b>
      </p>
      <p class="text tab-2">
        5.
        平台方有权对平台用户采取措施防范欺诈行为，如发现欺诈行为或其他损害其他平台用户利益的情形，平台有权及时终止该平台用户继续使用平台服务并要求用户承担平台因此产生的一切支出或损失。
      </p>
      <p class="text tab-2">
        6.
        平台服务的部分内容需要平台用户根据平台要求完成身份认证及银行卡认证，未进行身份认证及/或银行卡认证的平台用户将无法使用该部分平台服务。<b>因未能完成认证而无法享受平台服务造成的损失，平台不承担任何责任。</b>
      </p>
      <p class="text tab-2">
        7.
        平台对平台用户的通知及任何其他的协议、告示或其他关于平台用户使用平台账户及服务的通知，平台用户同意平台可通过平台公告、电子邮件、手机短信、无线通讯装置等电子方式或常规的信件传递、电话通讯等方式进行，该等通知于发送之日视为已送达收件人。<b>因信息传输等原因导致平台用户未在前述通知发出当日收到该等通知的，平台不承担责任。</b>
      </p>
      <p class="text tab-2"><b>三、平台服务内容</b></p>
      <p class="text tab-2">
        <b>1.
        平台服务由平台运营者提供并受各自相应服务协议约束，平台运营者可以根据业务发展需要，调整提供服务种类，平台将为用户提供包括但不限于以下服务，具体可参见相应平台服务协议中所载的服务内容或直接登录平台浏览：</b>
      </p>
      <p class="text tab-2">（1）提供个人消费借贷服务。</p>
      <p class="text tab-2">（2）提供持续贷后管理及借贷还款服务。</p>
      <p class="text tab-2">
        （3）信息展示服务，包括但不限于展示平台的第三方合作机构为平台用户打造的付费权益服务礼包等，具体以平台实际展示的第三方合作机构的服务内容为准。<b>请您知悉，平台提供第三方信息展示服务不代表平台运营者对第三方合作机构所提供的服务内容进行过任何实质性审查，或者进行任何明示或暗示的推荐。用户在使用第三方合作机构提供的服务内容前，应当根据自主判断点击所展示的第三方服务信息，并在仔细审阅第三方合作机构相应的个人信息保护政策与服务协议内容后，自主决定是否进行后续操作。</b>
      </p>
      <p class="text tab-2">
        <b>2.
        平台仅对发布的信息承担形式审查责任，不对信息的准确、完整、合法性作出保证，也不构成对任何第三方交易平台的推荐或进行实质性审查，平台用户应依其独立判断做出决策，平台不承担任何责任。</b>
      </p>
      <p class="text tab-2">
        3. 平台用户理解并同意，平台向平台用户提供信息展示服务。
      </p>
      <p class="text tab-2">
        <b>4.
        平台用户同意，平台有权在提供平台服务过程中以各种方式投放各种商业性广告或其他任何类型的宣传推广信息（包括商业与非商业信息，包括但不限于在平台的任何页面上投放广告），如不需要平台推送相关信息，平台用户可联系平台客服取消、退订该信息推送服务。</b>
      </p>
      <p class="text tab-2">
        5.
        平台无需平台用户同意即可向平台关联公司转让与平台有关的全部或部分权利和义务。<b>未经平台事先书面同意，平台用户不得转让其在本协议项下的任何权利和义务。</b>
      </p>
      <p class="text tab-2"><b>四、平台用户的义务</b></p>
      <p class="text tab-2">
        1.
        本协议依据国家相关法律法规及规章制定，平台用户同意并承诺将严格遵守以下义务：
      </p>
      <p class="text tab-2">
        （1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
      </p>
      <p class="text tab-2">
        （2）从中国境内向境外传输资料信息时必须符合中国有关法规；
      </p>
      <p class="text tab-2">
        （3）不得利用平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
      </p>
      <p class="text tab-2">
        （4）不得干扰平台的正常运转，不得侵入平台或国家计算机信息系统；
      </p>
      <p class="text tab-2">
        （5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；
      </p>
      <p class="text tab-2">
        （6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
      </p>
      <p class="text tab-2">（7）不得教唆他人从事本条所禁止的行为；</p>
      <p class="text tab-2">
        （8）不得利用在平台注册的账户进行牟利性经营活动；
      </p>
      <p class="text tab-2">
        （9） 不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容。
      </p>
      <p class="text tab-2">
        2.
        若您未遵守以上规定，平台有权作出独立判断并采取暂停或关闭账户、将违约或失信行为记录信用资料等措施，平台有权在任何形式的媒体上公布。您须对自己在网上的言论和行为承担法律责任。
      </p>
      <p class="text tab-2"><b>五、隐私权政策</b></p>
      <p class="text tab-2">
        <b>平台重视对用户隐私的保护。平台承诺会按照《个人信息保护政策》保护用户的个人信息；用户明确同意并授权平台按照《个人信息保护政策》收集、使用和分享用户的个人信息。详情请参阅《个人信息保护政策》。</b>
      </p>
      <p class="text tab-2"><b>六、免责声明</b></p>
      <p class="text tab-2">
        <b>1.
        除非另有书面协议约定，平台在任何情况下，对用户使用本平台服务而产生的任何形式的直接或间接损失均不承担法律责任，包括但不限于资金损失、利润损失、服务中断损失等。</b>
      </p>
      <p class="text tab-2">
        <b>2.
        任何平台之外的第三方所提供的服务，其服务品质及内容由该第三方自行、独立负责。</b>
      </p>
      <p class="text tab-2">
        <b>3.
        因不可抗力或服务器死机、网络故障、数据库故障、软件升级或发生自然灾害、战争、恐怖袭击或者其他无法控制的事件等问题造成的服务中断和对用户个人数据及资料造成的损失，平台不承担任何责任，亦不予赔偿。</b>
      </p>
      <p class="text tab-2">
        <b>4.
        因黑客、病毒或密码被盗、泄露等非平台原因所造成损失概由用户本人自行承担。</b>
      </p>
      <p class="text tab-2">
        <b>5.
        当司法机关、政府部门或其他监管机构根据有关法律、法规、规章及其他政府规范性文件的规定和程序，要求平台提供用户信息资料，平台对据此作出的任何披露，概不承担责任。</b>
      </p>
      <p class="text tab-2">
        <b>6.
        由于中国法律政策的变动或监管机关的要求导致平台开展的业务不被中国法律政策、监管机关允许或认可，由此造成的损失由用户自行承担，平台对此不承担责任。</b>
      </p>
      <p class="text tab-2"><b>七、风险提示</b></p>
      <p class="text tab-2">
        平台用户了解并认可，平台不会也没有义务为如下风险负责，但针对可能产生的风险进行如下揭示：
      </p>
      <p class="text tab-2">
        （1）鉴于网络服务的特殊性，平台不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。
      </p>
      <p class="text tab-2">
        （2）因以下情况造成网络服务在合理时间内的中断，平台无需为此承担任何责任：
      </p>
      <p class="text tab-2">
        a)
        平台需要定期或不定期地对平台或相关的设备进行检修或者维护，平台保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。
      </p>
      <p class="text tab-2">
        b)
        台风、地震、洪水、雷电、系统故障、设备故障、通讯故障、停电等突发事故，战争或恐怖袭击等不可抗力原因。
      </p>
      <p class="text tab-2">
        c) 用户的电脑软硬件和通信线路、供电线路出现故障。
      </p>
      <p class="text tab-2">
        d)
        病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。
      </p>
      <p class="text tab-2">
        尽管有前款约定，平台将采取合理行动积极促使服务恢复正常。
      </p>
      <p class="text tab-2">
        （3）平台或第三方可提供与其它互联网上之网站或资源之链接。由于平台无法控制这些网站及资源，您了解并同意，此类网站或资源是否可供利用，平台不予负责，存在或源于此类网站或资源之任何内容、广告、产品或其它资料，平台亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，平台不承担任何责任。
      </p>
      <p class="text tab-2">
        （4）用户明确同意其使用平台服务所存在的风险将完全由其自己承担。用户理解并接受下载或通过平台取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。平台对其任何服务、交易进程、广告信息等都不作担保。
      </p>
      <p class="text tab-2">
        （5）因平台用户的过错导致的任何损失，该过错包括但不限于：决策失误、操作不当、遗忘或泄露密码、密码被他人破解、平台用户使用的计算机系统被第三方侵入、平台用户委托他人代理交易时他人恶意或不当操作而造成的损失。
      </p>
      <p class="text tab-2"><b>八、知识产权条款</b></p>
      <p class="text tab-2">
        1.
        平台上所有内容，包括但不限于著作、图片、档案、资讯、资料、平台架构、平台画面的安排、网页设计，均由平台或其他权利人依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。非经平台或其他权利人书面同意，任何人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取、擅自使用、修改、公开传播、改变、散布、发行或公开发表平台程序或内容，否则平台或其他权利人有权追究其法律责任。
      </p>
      <p class="text tab-2">
        2.
        未经平台及其他权利人明确书面同意，任何人不得以任何商业目的对平台网站或其任何部分进行复制、复印、仿造、出售、转售、访问、或以其他方式加以利用。
      </p>
      <p class="text tab-2">
        3.
        尊重知识产权是平台用户应尽的义务，如有违反，平台用户应对平台及其他权利人承担损害赔偿等法律责任。
      </p>
      <p class="text tab-2"><b>九、责任限制及不承诺担保</b></p>
      <p class="text tab-2">
        1.
        除非另有明确的书面说明，平台及其所包含的或以其它方式通过网站或移动客户端提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。除非另有明确的书面说明，平台不对平台运营及其包含在平台上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的除外）。
      </p>
      <p class="text tab-2">
        2.
        平台不担保平台所包含的或以其它方式通过平台提供给平台用户的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从平台发出的电子信件、信息没有病毒或其他有害成分。
      </p>
      <p class="text tab-2">
        3.
        如因不可抗力或其它平台无法控制的原因使平台系统崩溃或无法正常使用导致平台服务无法完成或丢失有关的信息、记录等，平台会合理地尽力协助处理善后事宜。
      </p>
      <p class="text tab-2">
        4.
        基于互联网的特殊性，无法保证平台的服务不会中断，对于包括但不限于设备、系统存在缺陷，计算机发生故障、遭到病毒、黑客攻击或者发生地震、海啸等不可抗力而造成服务中断或因此给平台用户造成的损失，由平台用户自行承担。
      </p>
      <p class="text tab-2"><b>十、条款的解释、法律适用及争端解决</b></p>
      <p class="text tab-2">
        1.
        本协议是由您与平台运营者共同签订的，适用于您在平台的全部活动，平台及平台运营者有最终的解释权。
      </p>
      <p class="text tab-2">
        2.
        本协议不涉及您与其他平台用户之间因使用平台服务而产生的法律关系及法律纠纷。但您在此同意将全面接受并履行与其他平台用户在使用平台服务时签订的任何电子法律文本，并承诺按照该法律文本享有和（或）放弃相应的权利、承担和（或）豁免相应的义务。
      </p>
      <p class="text tab-2">
        3.
        如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，则应认为该条款可与本协议相分割，并可被尽可能接近各方意图的、能够保留本协议要求的经济目的的、有效的新条款所取代，而且，在此情况下，本协议的其他条款仍然完全有效并具有约束力。
      </p>
      <p class="text tab-2">
        4.
        本协议及其修订的有效性、履行与本协议及其修订效力有关的所有事宜，将受中华人民共和国（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区和台湾地区）法律管辖。
      </p>
      <p class="text tab-2">
        5.
        因本协议所引起的平台用户与平台、平台运营者的任何纠纷或争议，首先应友好协商解决，协商不成的，平台用户在此完全同意将纠纷或争议提交平台运营者主要办事机构所在地重庆市渝中区有管辖权的人民法院诉讼解决。
      </p>
      <p class="text tab-2">最近更新日期：2023年12月12日</p>
    </section>
    <p
      data-sensors-exposure-property-page_status="page_bottom"
      data-sensors-exposure-event-name="general_event"
    >&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>

<script>

export default {
  name: 'login-protocol',
  created () {
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .login-protocol {
        background-color: white;

        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>
